import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { AvailableCarRentals } from "../interfaces/carRental";
import { CarExtra } from "../interfaces/carExtra";
import { AvailableCarExtra } from "../interfaces/availableCarExtra";

export interface CarRentalState {
    availableCarRentals: AvailableCarRentals | [],
    availableExtras: AvailableCarExtra[],
    carRentals: any,
    carExtras: CarExtra[]
}

export const carRentalInitialState: CarRentalState = {
    availableCarRentals: [],
    availableExtras: [],
    carRentals: {},
    carExtras: []
}

export default {
    namespaced: false,
    state: carRentalInitialState,
    mutations,
    actions,
    getters
}
